import Highcharts from 'highcharts';

import { InsightsChartSpec } from 'services/streamInsightsQuery';

import { baseInsightsOptions, formatChartValue, valueAxis } from './shared';

// waterfall — each category's value stacked on the running total, closed by a
// computed Total bar. Single series (the saved gadget plots series[0] only) and
// no legend: the colours encode rise/fall/sum, not metrics.
const buildWaterfallOptions = (spec: InsightsChartSpec): Highcharts.Options => {
  const base = baseInsightsOptions({
    spec,
    chartType: 'waterfall',
    usePointName: false,
    showLegend: false,
  });

  const values = spec.series[0]?.data ?? [];

  return {
    ...base,
    series: [
      {
        type: 'waterfall',
        name: spec.series[0]?.name,
        // The trailing isSum point makes Highcharts draw the accumulated total,
        // matching the saved gadget's appended 'Total' bar.
        data: [...values, { name: 'Total', isSum: true }],
        dataLabels: {
          enabled: true,
          style: { color: 'var(--color-text-primary)', textOutline: 'none' },
          formatter(this: Highcharts.PointLabelObject): string {
            return formatChartValue(this.y ?? 0, spec.formatting);
          },
        },
      },
    ] as unknown as Highcharts.SeriesOptionsType[],
    xAxis: {
      categories: [...spec.categories, 'Total'],
      // See valueAxis in ./shared — axis titles repeat the chart title here.
      title: { text: undefined },
    },
    yAxis: valueAxis(spec),
  };
};

export default buildWaterfallOptions;
